module.exports = __webpack_public_path__ + "img/bus-station-orange.9d6ca537.svg";